export default "__VITE_ASSET__DBm4L6pb__"